export default "__VITE_ASSET__CPXsj1UX__"